<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="spinner">
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>

<div class="header-container">
  <div>
    <h1 id="header-text">Load GFS Vehicle Portfolio</h1>
  </div>

  <div class="export-current-portfolio-container">
    <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedPortType">
      <mat-radio-button [value]="BUSINESS_PLAN">{{ BUSINESS_PLAN }}</mat-radio-button>

      <mat-radio-button class="radio-options" [value]="TVP">{{ TVP }}</mat-radio-button>
    </mat-radio-group>
    <br/>
    <button mat-raised-button id="export-current-portfolio-button"
            class="export-current-portfolio-button"
            color="primary"
            (click)="exportCurrentPortfolioByPortType(selectedPortType)">Export Current Portfolio
    </button>
  </div>

  <div class="options">
    <div>
      <app-upload-button [apiUrl]="vehPortfolioService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>
    </div>

    <div>
      <app-export-button id="export-button" class="no-custom-text"
                         [excelExportService]="vehPortfolioService"
                         [disabled]="!hasData"
                         [color]="exportButtonColor"
                         [worksheetExportRequest]="worksheetExportRequest">
        Export
      </app-export-button>
    </div>

    <div>
      <button mat-raised-button color="primary" id="load-button" class="action-button"
              (click)="validate(portfolioData)"
              [disabled]="isLoadButtonDisabled">
        Load
      </button>
    </div>

  </div>
</div>

<!-- Tabs -->
<mat-tab-group mat-stretch-tabs="false" mat-stretch-tabs="false" #portfolioTabGroup *ngIf="portfolioTabs.length > 0"
               (selectedTabChange)="fcorgTabChange($event)"
               [(selectedIndex)]="fcorgTabIndex">
  <mat-tab *ngFor="let tab of portfolioTabs" [label]="tab" id="{{tab}}"></mat-tab>
</mat-tab-group>

<!-- Violation tabs -->
<mat-tab-group mat-stretch-tabs="false" #violationTabGroup *ngIf="hasViolations"
               (selectedTabChange)="violationTabChange($event)"
               [(selectedIndex)]="violationTabIndex">
  <mat-tab label="Duplicate Arch per 7key" id="duplicateEngDtlTab"
           *ngIf="violations.multArchPerSevenKeyList.length > 0"></mat-tab>
  <mat-tab label="Duplicate Engctr per 7key" id="duplicateTranDtlTab"
           *ngIf="violations.multEngCtrPerSevenKeyList.length > 0"></mat-tab>
  <mat-tab label="Inactive Plngmkt Records" id="inactivePlngmktTab"
           *ngIf="violations.inactivePlngMktList.length > 0"></mat-tab>
  <mat-tab label="Invalid Recstat Records" id="invalidRecstatTab"
           *ngIf="violations.invalidRecStatList.length > 0"></mat-tab>
  <mat-tab label="Duplicate Recids" id="invalidRecidTab"
           *ngIf="violations.duplicateRecIdDtoList.length > 0"></mat-tab>
  <mat-tab label="Duplicate Entries" id="duplicateEntriesTab"
           *ngIf="violations.duplicateEntryList.length > 0"></mat-tab>
  <mat-tab label="Invalid Date Records" id="invalidDatesTab"
           *ngIf="violations.invalidDateList.length > 0"></mat-tab>
  <mat-tab label="Invalid Port Type Records" id="invalidPortTypeTab"
           *ngIf="violations.invalidPortTypeList.length > 0"></mat-tab>
  <mat-tab label="Invalid Iteration Records" id="invalidIterationTab"
           *ngIf="violations.invalidIterationList.length > 0"></mat-tab>
</mat-tab-group>

<!-- Result tabs -->
<mat-tab-group mat-stretch-tabs="false" #resultTabGroup *ngIf="hasResults" (selectedTabChange)="resultTabChange($event)"
               [(selectedIndex)]="resultTabIndex">
  <mat-tab label="New Portfolio" id="newPortfolio" *ngIf="vehPortLoadResults.newPortfolio.length > 0"></mat-tab>
  <mat-tab label="Old Portfolio" id="oldPortfolio" *ngIf="vehPortLoadResults.oldPortfolio.length > 0"></mat-tab>
  <mat-tab label="Gseg Audit" id="gSegAudit" *ngIf="vehPortLoadResults.gsegAudit.length > 0"></mat-tab>
  <mat-tab label="Rejects" id="rejects" *ngIf="vehPortLoadResults.rejects.length > 0"></mat-tab>
  <mat-tab label="Changed Records" id="changedRecords"></mat-tab>
  <mat-tab label="Deleted Records" id="deletedRecords"></mat-tab>
  <mat-tab label="New Records" id="newRecords"></mat-tab>
</mat-tab-group>

<!-- Main Option Table -->
<div class="h-100" *ngIf="hasData || hasViolations">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="displayedData"
      [columnDefs]="displayedColDef"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
